import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b0f522"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filter-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "경유 노선 유형", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.lineTypeCheckList.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lineTypeCheckList, (type, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "filter-row",
            key: index
          }, [
            _createVNode($setup["LineTypeChip"], {
              lineTypeCode: (type.lineTypeCode as LineTypeCode),
              lineTypeName: (type.lineTypeName as LineTypeName)
            }, null, 8 /* PROPS */, ["lineTypeCode", "lineTypeName"]),
            _createVNode($setup["CheckboxInput"], {
              value: type.checked,
              onOnChangedCheck: ($event: any) => ($setup.onChangedCheck($event, index))
            }, null, 8 /* PROPS */, ["value", "onOnChangedCheck"])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}